import * as React from 'react';
const ListItemButtonOrientationContext = /*#__PURE__*/React.createContext('horizontal');
if (process.env.NODE_ENV !== 'production') {
  ListItemButtonOrientationContext.displayName = 'ListItemButtonOrientationContext';
}
export default ListItemButtonOrientationContext;